import { Component } from '@angular/core';

@Component({
  selector: 'app-management-fees',
  standalone: true,
  imports: [],
  templateUrl: './management-fees.component.html',
  styleUrl: './management-fees.component.css'
})
export class ManagementFeesComponent {

}
